import FormSubmitProps from "@/src/types/FormSubmitProps";
import PersonalMessage from "@/src/components/Form/AbstractLitigationCase/PersonalMessage";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type EmploymentContractDescriptionProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
  applicationStatus: number;
};

export default function EmploymentContractDescription({ submitProps, product, applicationStatus }: EmploymentContractDescriptionProps) {
  return <PersonalMessage submitProps={submitProps} product={product} applicationStatus={applicationStatus} />;
}
